import {
  IImbpBookingRaw,
  ImbpBookingParser,
} from "@/models/imbpBooking/imbpBooking.parser"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ImbpBookingInformation } from "./imbpBookingInformation"
import { IImbpBookingInformation } from "./imbpBookingInformation.types"

export interface IImbpBookingInformationRaw {
  bookings: IImbpBookingRaw[]
}

export const ImbpBookingInformationParser: IParser<
  IImbpBookingInformation,
  IImbpBookingInformationRaw
> = {
  toDomain: (data: IImbpBookingInformationRaw) => {
    try {
      return new ImbpBookingInformation({
        bookings: data.bookings.map((booking) =>
          ImbpBookingParser.toDomain(booking),
        ),
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
